import React from 'react';
import notAuthorizedImage from '../../../assets/images/notAuthorizedImage.jpg';

const NotAuthorized = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white-900">
      <h1 className="text-4xl font-bold mb-4">401 - Not Authorized</h1>
      <p className="text-gray-600 text-lg mb-8">
        Oops! You are not authorized to access this page.
      </p>
      <img
        src={notAuthorizedImage}
        alt="401 Error"
        className="w-[30rem] h-auto mb-8"
      />
      <a
        href="/"
        className="px-4 py-2 text-white bg-blue-400 hover:bg-blue-600 rounded-md transition-colors"
      >
        Go back to homepage
      </a>
    </div>
  );
};

export default NotAuthorized;